import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";

const useDeleteExceptions = () => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const destroy = async (ids) => {
		const instance = await InitApi({ accessToken });
		const response = await instance.delete("/reported-exceptions", {
			data: { ids },
		});
		return response?.data;
	};

	return useMutation(destroy, {
		onSuccess: async (body) => {
			await queryClient.invalidateQueries("exceptions");
			toast.success(body.message);
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{ className: "max-w-max" }
			);
		},
	});
};

export default useDeleteExceptions;
